export const GET_ADMIN_USER_DATA_REQUEST =
  '@admin/dashboard/GET_ADMIN_USER_DATA_REQUEST';
export const GET_ADMIN_USER_DATA_SUCCESS =
  '@admin/dashboard/GET_ADMIN_USER_DATA_SUCCESS';
export const GET_ADMIN_USER_DATA_FAILURE =
  '@admin/dashboard/GET_ADMIN_USER_DATA_FAILURE';
